import React, { useRef } from 'react';
import { Button, FormControl, FormLabel, Input, Drawer, DrawerBody, DrawerFooter, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, Slide, AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay, useDisclosure } from '@chakra-ui/react';

const JobPostingDrawer = ({ isOpen, onClose, onPostJob }) => {
  const titleRef = useRef();
  const descriptionRef = useRef();
  const { isOpen: isAlertOpen, onOpen: onAlertOpen, onClose: onAlertClose } = useDisclosure();
  const cancelRef = useRef();

  const handleSubmit = () => {
    const jobDetails = {
      title: titleRef.current.value,
      description: descriptionRef.current.value,
    };
    onPostJob(jobDetails);
    onAlertClose();
    onClose();
  };

  return (
    <Slide direction="bottom" in={isOpen} style={{ zIndex: 2000 }}>
      <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} isCentered size="full">
        <DrawerOverlay />
        <DrawerContent
          backgroundColor="rgba(42, 42, 49, 0.8)"
          boxShadow="0 4px 8px rgba(0, 0, 0, 0.2)"
          color="white"
          maxH="75%"
          mx="auto"
          py={4}
        >
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">Post a Job</DrawerHeader>

          <DrawerBody overflowY="auto">
            <FormControl isRequired>
              <FormLabel>Title</FormLabel>
              <Input ref={titleRef} placeholder="Job title" />
            </FormControl>
            <FormControl mt={4} isRequired>
              <FormLabel>Description</FormLabel>
              <Input ref={descriptionRef} placeholder="Job description" />
            </FormControl>
          </DrawerBody>

          <DrawerFooter borderTopWidth="1px" mb="40px">
            <Button colorScheme="blackAlpha" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme="blue" onClick={onAlertOpen}>
              Post
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>

      <AlertDialog
        isOpen={isAlertOpen}
        leastDestructiveRef={cancelRef}
        onClose={onAlertClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent backgroundColor="rgba(42, 42, 49, 0.8)" color="white">
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Post Job
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to post the job? You can't undo this action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onAlertClose}>
                Cancel
              </Button>
              <Button colorScheme="blue" onClick={handleSubmit} ml={3}>
                Post
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Slide>
  );
};

export default JobPostingDrawer;
